((global) => {
  /**
   * @class TextScroller
   * @description This class and attributes are a utility to add a text scroller
   * originally for the model hub used in model-hub.js
   * @file global/js/modules/text-scroller.js
   */
  class TextScroller {
    static getTextScrollerSize() {
      return this.textScroller.scrollWidth;
    }

    static getTextScrollerListSize() {
      return this.textScrollerList.scrollWidth;
    }

    static getTextScrollerListPosition() {
      return this.textScrollerList.scrollLeft;
    }

    /**
     *  Function to scroll in a direction depending on variables passed
     * @param {HTMLElement} element The element we want to scroll
     * @param {string} direction The direction we want to scroll
     * @param {number} speed The speed in which the scroll will happen
     * @param {number} distance The amount of pixels to travel
     * @param {number} step
     */
    static sideScroll(element, direction, speed, distance, step) {
      this.scrollAmount = 0;
      const slideTimer = setInterval(() => {
        if (direction === 'left') {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        this.scrollAmount += step;
        if (this.scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    }

    /**
     * Init the scroller and it's dependencies
     */
    static initScroller() {
      this.controlMargin = 20;
      this.textScroller = document.querySelector('.js-text-scroller');
      this.textScrollerList = this.textScroller.querySelector('.text-scroller__list');
      this.scrollL = this.textScroller.querySelector('.text-scroller__control--left');
      this.scrollR = this.textScroller.querySelector('.text-scroller__control--right');
      this.textScrollerSize = this.textScroller.scrollWidth;

      window.addEventListener('resize', () => {
        this.textScrollerSize = this.getTextScrollerSize();
      });

      this.textScrollerListSize = this.getTextScrollerListSize();
      this.textScrollerInvisibleSize = this.textScrollerListSize - this.textScrollerSize;

      // Hide the arrows if the list size is smaller than the scroller size and arrow width
      if (this.textScrollerListSize < this.textScrollerSize - this.scrollR.offsetWidth + 10) {
        this.scrollR.classList.add('hide__default');
      } else {
        this.scrollR.classList.remove('hide__default');
      }

      this.textScrollerList.addEventListener('scroll', () => {
        this.textScrollerInvisibleSize = this.textScrollerListSize - this.textScrollerSize;

        this.textScrollerListPosition = this.getTextScrollerListPosition();
        this.textScrollerListEndOffset = this.textScrollerInvisibleSize - this.controlMargin;

        // Show and hide the arrows dependent on the widths
        if (this.textScrollerListPosition <= this.controlMargin) {
          this.scrollL.classList.add('hide__default');
          this.scrollR.classList.remove('hide__default');
        } else if (this.textScrollerListPosition < this.textScrollerListEndOffset) {
          this.scrollL.classList.remove('hide__default');
          this.scrollR.classList.remove('hide__default');
        } else if (this.textScrollerListPosition >= this.textScrollerListEndOffset) {
          this.scrollL.classList.remove('hide__default');
          this.scrollR.classList.add('hide__default');
        }
      });

      /**
       * Add event listeners to the navigation
       */
      this.scrollR.addEventListener('click', () => {
        this.sideScroll(this.textScrollerList, 'right', 5, 320, 8);
      });

      this.scrollL.addEventListener('click', () => {
        this.sideScroll(this.textScrollerList, 'left', 5, 320, 8);
      });
    }
  }

  global.TextScroller = TextScroller;
})(window);
